import React from 'react'
import Calculate_Personal_Loan_Emi from '../../Common_Component/Calculate_Personal_Loan_Emi/Calculate_Personal_Loan_Emi'

function See_Your_EMI() {
  return (
    <>
        <Calculate_Personal_Loan_Emi heading="Know Your Personal Loan Eligibility
        and EMI"  />
    </>
  )
}

export default See_Your_EMI